import { useState, useEffect, useRef } from "react";
import {
  Button,
  Form,
  Input,
  Dropdown,
  Col,
  Row,
  Progress,
  Tooltip,
  Spin,
  Menu,
  Select,
  Tree,
  Badge,
  Space,
  Avatar,
  Checkbox,
  Splitter,
} from "antd";
import {
  ClockCircleOutlined,
  FileImageOutlined,
  UploadOutlined,
  CommentOutlined,
  VideoCameraOutlined,
  UserOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { FolderPlus, Search, LeftTwo, Right } from "@icon-park/react";
import axios from "axios";
import fileclose from "../../assets/img/fileclose.png";
import smallIcon from "../../assets/img/grid.svg";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { capitalizeExceptPrepositionsAndLowerCase } from "../../common/CapitalLetter/CapitalLetterWithoutPrepositions";
import dayjs from "dayjs";
import Delete from "../../components/modalDelete/Delete";
import noFoundImg from "../../assets/img/empty.png";
import { useSelector } from "react-redux";
//base url import
import { Table } from "antd";
import { DocBaseUrl } from "../../utils/configurable";
import { useFetch } from "../../Services/useFetch";
import FolderCreateUpdate from "../../components/folderCreate/folderCreation";
import UserProfile from "../../components/userProfile/UserProfile";
import Dashboard from "../BDDashboard/Dashboard";
import RenameDocument from "../../components/renameDocument/RenameDocument";
import UploadDoc from "../../components/uploadDoc/UploadDoc";
import RightBrief from "./RightBrief";
import useBreadcrumb from "../../hooks/breadcrumb/useBreadcrumb";
import useFindSelectedNode from "../../hooks/findSelectedNode/useFindSelectedNode";
import useCheckParentKeyExist from "../../hooks/checkParentKey/useCheckParentKeyExist";
import useDocumentViewer from "../../hooks/documentPreview/useDocumentPreview";
import ShowImage from "./showImg";
import CommentModal from "../../components/commentModel/CommentModal";
import ShareFile from "../../components/shareFiles/ShareFiles";
import ProtectedFolder from "../../components/protectedFolder/ProtectedFolder";
import { io } from "socket.io-client";
import AppsIcon from "@mui/icons-material/Apps";
import { fetchAuthMode, ssoAppsUrl } from "../../utils/docGridSso";
import { DocGridSocketUrl } from "../../utils/configurable";
import FileCreateUpdate from "../../components/fileCreate/fileCreation";
// import DraggableItem from "../../components/DragableItem";

const socket = io(DocGridSocketUrl);

const { DirectoryTree } = Tree;
const initialState = {
  parent_id: "",
  folder_name: "",
  document_title: "",
  document_file_name: [],
};

const columns = [
  {
    title: "S.NO",
    key: "index",
    render: (_, __, index) => index + 1,
    width: "10%",
    align: "center",
  },
  {
    title: "Folder / File Name",
    dataIndex: "document_file_name",
    key: "document_file_name",
    width: "30%",
    align: "center",
  },
  {
    title: "Path",
    dataIndex: "path",
    key: "path",
    width: "30%",
    align: "center",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    width: "20%",
    align: "center",
  },
];

const sortingOption = [
  {
    value: "xl",
    label: (
      <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25px"
          height="25px"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25"
          />
        </svg>

        <p>Extra large Icons</p>
      </div>
    ),
    zoom: 4,
    height: 250,
  },
  {
    value: "l",
    label: (
      <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20px"
          height="20px"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25"
          />
        </svg>

        <p>Large Icons</p>
      </div>
    ),
    zoom: 6,
    height: 200,
  },
  {
    value: "m",
    label: (
      <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18px"
          height="18px"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25"
          />
        </svg>

        <p>Medium Icons</p>
      </div>
    ),
    zoom: 8,
    height: 170,
  },
  {
    value: "s",
    label: (
      <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
        <img src={smallIcon} style={{ width: "20px", height: "20px" }} />

        <p>Small Icons</p>
      </div>
    ),
    zoom: 10,
    height: 134,
  },
];

function Briefcase() {
  const fileInputRef = useRef(null);
  const folderRef = useRef(null);
  const selectAllCheckboxRef = useRef(null);
  const unLockedRef = useRef();
  const { userInfo } = useSelector((state) => state.userDetails);
  const CheckboxGroup = Checkbox.Group;

  const [basicModal, setBasicModal] = useState(false);
  const [openFileCreate, setOpenFileCreate] = useState(false);
  const [uploadDocModal, setUploadDocModal] = useState(false);
  const [showInnerFolder, setShowInnerFolder] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [esc, setEsc] = useState(false);
  const [spinLoader, setSpinLoader] = useState(true);
  const [selectedKey, setSelectedKey] = useState(0);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [resetNodeData, setResetNodeData] = useState({});
  const [treeDataRight, setTreeDataRight] = useState([]);
  const [treeDataLeft, setTreeDataLeft] = useState([]);
  const [combinedResponse, setCombinedResponse] = useState([]);
  const [search, setSearch] = useState("");
  const [renameFolder] = Form.useForm();
  const [shareData] = Form.useForm();
  const [lockData] = Form.useForm();
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [Permission, setPermission] = useState("");
  const [modalData, setModalData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(40);
  const [totalData, setTotalData] = useState(0);
  const [uploadingFolder, setUploadingFolder] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(8);
  const [gridHeight, setGridHeight] = useState(150);
  const [loadings, setLoadings] = useState({
    loadingFolder: false,
    loadingFile: false,
  });
  const [visibleCount, setVisibleCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCountData, setTotalCountData] = useState();
  const [openRenameFolder, setOpenRenameFolder] = useState(false);
  const [currentFolderKey, setCurrentFolderKey] = useState();
  const [dataNew, setDataNew] = useState();
  const [callApi, setCallApi] = useState(false);
  const [hoveredKey, setHoveredKey] = useState(null);
  const [showFilteredData, setShowFilteredData] = useState(false);
  const [filtereData, setFilterData] = useState();
  const [folderSlug, setFolderSlug] = useState();
  const [renameKeys, setRenameKeys] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [fileIDs, setFileIDs] = useState([]);
  const [folderIDs, setFolderIDs] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [showDataAcc, setShowDataAcc] = useState([]);
  const [fileType, setFileType] = useState();
  const [commentModal, setCommentModal] = useState(false);
  const [showComments, setShowComments] = useState([]);
  const [currentItemData, setCurrentItemData] = useState();
  const [downloadingProgress, setDownloadingProgress] = useState(0);
  const [downloading, setDownloading] = useState(false);
  const [moveFilesIds, setMoveFilesIds] = useState([]);
  const [moveSlug, setMoveSlug] = useState("");
  const [shareFileOpen, setShareFileOpen] = useState(false);
  const [lockOpen, setLockOpen] = useState(false);
  const [protectedLockData, setProtectedLockData] = useState();
  const [protectedSlug, setProtectedSlug] = useState("");
  const [backClickCount, setBackClickCount] = useState(0);
  const [outerPermission, setOuterPermission] = useState("");
  const [shareLink, setShareLink] = useState("");
  const [activeUserCount, setActiveUserCount] = useState();
  const [folderSearch, setFolderSearch] = useState("");

  const [contextMenu, setContextMenu] = useState(null);

  const notify = (error) => toast.error(error);
  const notifySuccess = (msg) => toast.success(msg);
  const { breadcrumbSlug, setBreadcrumbSlug, handleBreadcrumb } = useBreadcrumb();
  const { findSelectedNode, selectedNodeData, setSelectedNodeData } = useFindSelectedNode();
  const { checkParentKeyExist } = useCheckParentKeyExist(expandedKeys, combinedResponse);
  const { onFilterDocClick } = useDocumentViewer();
  const { request } = useFetch();
  const scrollRef = useRef(null);
  const debounceTimeout = useRef(null);
  const navigate = useNavigate();
  const hasPasteItems = Array.isArray(moveFilesIds) ? moveFilesIds.length > 0 : !!moveFilesIds; // true if it's a non-null single object

  const renameLabel = Array.isArray(Permission) && Permission[0]?.is_rename == "1" ? "Rename" : null;

  const handleLoading = (key, value) => {
    setLoadings((prevLoadings) => ({
      ...prevLoadings,
      [key]: value,
    }));
  };

  const handleZoomdropdown = (selectedValue) => {
    const selectedOption = sortingOption.find((option) => option.value === selectedValue);
    if (selectedOption) {
      setZoomLevel(selectedOption.zoom);
      setGridHeight(selectedOption.height);
      zoomLevel >= 8 && setPageSize(50);
    }
  };

  const handleShowDataAcc = async (type) => {
    const formData = new URLSearchParams();
    formData.append("comp_id", 31);
    formData.append("folder_id", 1);
    try {
      const response =
        type == "image"
          ? await request("/user-image", "get", formData, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          : type == "recent"
            ? await request("/recent-files", "get", null, {
              "Content-Type": "application/x-www-form-urlencoded",
            })
            : await request("/user-video", "get", null, {
              "Content-Type": "application/x-www-form-urlencoded",
            });
      if (response?.data?.status == 1) {
        setShowDataAcc(response?.data?.data);
        setFileType(type);
      } else {
        notify(response?.response?.data?.message);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const handleAddCommentList = async (item) => {
    setCurrentItemData(item);
    setCommentModal(true);
    const formData = new URLSearchParams();
    formData.append("file_id", item?.key);
    formData.append("folder_id", item?.parent_id);
    try {
      const response = await request("/comment-list", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });
      if (response?.data?.status == 1) {
        setShowComments(response?.data?.data);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const TransformLeftNodes = (apiData) => {
    const transformedData = [];
    const visited = {};

    const buildTree = (parentId) => {
      if (visited[parentId]) {
        return [];
      }
      visited[parentId] = true;

      const children = apiData.filter(
        (folder) => folder?.parent_id === parentId && !folder.hasOwnProperty("document_file_name")
      );

      const nodes = children.map((child) => {
        const node = {
          title: capitalizeExceptPrepositionsAndLowerCase(child.folder_name),
          key: child.id,
          type: child.type,
          parent_id: child?.parent_id,
          is_locked: child?.is_locked,
          permissions: child?.permissions,
          icon: <img src={fileclose} width={17} alt="" loading="lazy" />,
        };

        // Recursively build nested children for all folders
        const nestedChildren = buildTree(child.id);
        if (nestedChildren.length > 0) {
          node.children = nestedChildren;
        }

        return node;
      });

      return nodes;
    };

    // Always start from root (0) to build complete tree
    transformedData.push(...buildTree(0));

    return transformedData;
  };

  const TransformRightNodes = (apiData, currentFolderId) => {
    const transformedData = [];
    const visited = {};

    const dataMap = {};
    apiData?.forEach((item) => {
      dataMap[item.id] = item;
    });

    const buildTree = (parentId) => {
      if (visited[parentId]) {
        return [];
      }
      visited[parentId] = true;

      const children = apiData?.filter((folder) => folder?.parent_id === parentId);

      if (!children || children.length === 0) {
        return [];
      }

      return children.map((child) => {
        const permissions = child?.permissions ? child?.permissions : dataMap[child?.parent_id]?.permissions;

        const node = {
          selected_type: child.document_file_name ? "file" : "folder",
          title: capitalizeExceptPrepositionsAndLowerCase(child.folder_name || child.document_file_name),
          document_file_name: child.document_file_name,
          document_file_path: child.document_file_path,
          document_thambnail_path: child.document_thambnail_path,
          parent_id: child?.parent_id,
          is_fav: child?.is_fav,
          is_locked: child?.is_locked,
          commit_count: child?.commit_count,
          key: child.id,
          type: child.type || "file",
          permissions: permissions,
          created_at: dayjs(child?.created_at).format("YYYY-MM-DD HH:mm:ss"),
          document_title: child?.document_title,
          icon: <img src={fileclose} width={17} alt="" loading="lazy" />,
        };

        // For right tree, we typically don't need nested children
        // since we're showing the current folder's contents
        const nestedChildren = buildTree(child.id);
        if (nestedChildren.length > 0) {
          node.children = nestedChildren;
        }

        return node;
      });
    };

    // For right tree, we want to show children of the current folder
    const startingParentId = currentFolderId || 0;
    transformedData.push(...buildTree(startingParentId));

    return transformedData;
  };

  const fetchBriefFolderList = async (id) => {
    setSpinLoader(true);
    const formData = new URLSearchParams();
    formData.append("pageSize", pageSize);
    formData.append("page", currentPage);
    formData.append("folder_id", id || 0);

    const newformData = new URLSearchParams();
    newformData.append("folder_id", id || "");

    try {
      const [folderResponse, fileResponse] = await Promise.all([
        request("/listgenral-doctroal", "post", newformData, {
          "Content-Type": "application/x-www-form-urlencoded",
        }),
        request("/doctrol-files-list", "post", formData, {
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      ]);

      if (folderResponse?.data?.status === "1" || fileResponse?.data?.status === "1") {
        const folderData = folderResponse?.data?.data?.filter((item) => item?.permissions[0]?.can_access) || [];

        const fileData = fileResponse?.data?.data || [];

        let combinedData = callApi ? [...dataNew, ...fileData] : fileData;

        let updatedCombinedResponse = [...combinedResponse];

        // Remove deleted item
        if (modalData) {
          const items = Array.isArray(modalData) ? modalData : [modalData];
          const idsToRemove = items.map((i) => i.key);

          updatedCombinedResponse = updatedCombinedResponse.filter((item) => !idsToRemove.includes(item.id));
        }

        // Add new folders
        folderData.forEach((newFolder) => {
          const existingIndex = updatedCombinedResponse.findIndex((item) => item.id === newFolder.id);
          if (existingIndex === -1) {
            updatedCombinedResponse.push(newFolder);
          } else {
            updatedCombinedResponse[existingIndex] = newFolder;
          }
        });

        // Add new files
        combinedData.forEach((newFile) => {
          const existingIndex = updatedCombinedResponse.findIndex((item) => item.id === newFile.id);
          if (existingIndex === -1) {
            updatedCombinedResponse.push(newFile);
          } else {
            updatedCombinedResponse[existingIndex] = newFile;
          }
        });

        const apiresponses = updatedCombinedResponse;

        // Pass current folder ID to transform functions
        const [transformedDataLeft, transformedDataRight, selectedNodeDatas] = await Promise.all([
          TransformLeftNodes(apiresponses, id),
          TransformRightNodes(apiresponses, id),
          findSelectedNode(apiresponses, id),
        ]);

        setTotalData(fileResponse?.data?.pagination);
        setDataNew(combinedData);
        setCombinedResponse(apiresponses);
        setSelectedNodeData(selectedNodeDatas[0]);
        setTreeDataLeft(transformedDataLeft);
        setTreeDataRight(transformedDataRight);
        setShowDataAcc([]);
        setCallApi(false);
        localStorage.setItem("folderId", id);

        setSpinLoader(false);
        setVisibleCount(0);
        if (scrollRef.current) {
          scrollRef.current.scrollTop = 0;
        }
        totalCountDataFun(id);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setSpinLoader(false);
    }
  };

  useEffect(() => {
    fetchBriefFolderList(selectedKey);
  }, [selectedKey, pageSize, currentPage]);

  // "All apps" opens the central login's applications page (idp mode only).
  const [isIdpMode, setIsIdpMode] = useState(false);

  useEffect(() => {
    fetchAuthMode().then((mode) => setIsIdpMode(mode === "idp"));
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, []);

  const fetchBriefPermission = async () => {
    setSpinLoader(true);
    try {
      const formData = new URLSearchParams();
      formData.append("event_name", "is_view");
      formData.append("user_id", userInfo?.id);
      const response = await request("/briefcash-permission-list", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });
      if (response?.data?.status === "1") {
        setPermission(response?.data?.data);
      }
    } catch (error) {
      console.log("error", error);
      setSpinLoader(false);
    }
  };

  useEffect(() => {
    if (userInfo?.id) {
      fetchBriefPermission();
    }
  }, [userInfo?.id]);

  const onExpand = (keys, info) => {
    const unlocked = JSON.parse(sessionStorage.getItem("unlockedFolders") || "[]");
    const isUnlocked = unlocked.includes(info?.node?.key);

    if (info?.node?.is_locked || isUnlocked) {
      setExpandedKeys(keys);
    }
  };

  useEffect(() => {
    if (!selectedNodeData || !Array.isArray(selectedNodeData.children)) return;

    const fileTypePriority = {
      folder: 0,
      video: 1,
      image: 2,
      other: 3,
    };

    const getFileType = (item) => {
      if (!item.document_file_name || !item.document_file_path || !item.document_thambnail_path) {
        return "folder";
      }

      const fileExtension = item.document_file_name.split(".").pop().toLowerCase();
      if (["mp4"].includes(fileExtension)) {
        return "video";
      }
      if (["jpg", "jpeg", "webp", "png", "zip", "rar"].includes(fileExtension)) {
        return "image";
      }
      return "other";
    };

    const sortedData = [...selectedNodeData.children].sort((a, b) => {
      const typeA = fileTypePriority[getFileType(a)];
      const typeB = fileTypePriority[getFileType(b)];

      if (typeA === typeB) {
        return a.title.localeCompare(b.title);
      }
      return typeA - typeB;
    });
    setSelectedNodeData((prevData) => {
      if (JSON.stringify(prevData?.children) !== JSON.stringify(sortedData)) {
        return {
          ...prevData,
          children: sortedData,
        };
      }
      return prevData;
    });
  }, [selectedNodeData]);

  const onSelect = async (selectedKeys, info) => {
    setOuterPermission(info?.selectedNodes[0]?.permissions[0]?.can_create);

    const unlocked = JSON.parse(sessionStorage.getItem("unlockedFolders") || "[]");
    const isUnlocked = unlocked.includes(selectedKeys[0]);
    if (info?.selectedNodes[0]?.is_locked == 1 || isUnlocked) {
      setShowDataAcc([]);
      setFileType("");
      setShowFilteredData(false);
      setSearch("");
      setSelectedKey(selectedKeys[0]);
      const selectedNode = findNodeByKey(treeDataRight, selectedKeys[0]);
      // setSelectedNodeData(selectedNode);
      // setResetNodeData(selectedNode);
      const breadcrumbs = handleBreadcrumb(selectedNode, combinedResponse);
      setBreadcrumb(breadcrumbs);
      setShowInnerFolder(true);
      setVisibleCount(0);
      socket.emit("join-folder", {
        folderId: selectedKeys[0],
        userId: userInfo?.id,
        userName: userInfo?.userfullname,
      });

      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0;
      }
    } else {
      setLockOpen(true);
      setProtectedLockData(info?.selectedNodes[0]);
      setProtectedSlug("unlock");
    }
  };

  const findNodeByKey = (data, key) => {
    for (let i = 0; i < data.length; i++) {
      const node = data[i];
      if (node.key === key) {
        return node;
      }
      if (node.children) {
        const foundNode = findNodeByKey(node.children, key);
        if (foundNode) {
          return foundNode;
        }
      }
    }
    return null;
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleDeleteModal = (items, value) => {
    setModalData(items);
    setDeleteModal(true);
  };

  const handleRenameFolder = (item, value) => {
    setCurrentFolderKey(item);
    setOpenRenameFolder(true);
    setRenameKeys(value);
    renameFolder?.setFieldsValue({
      folder_name: value == "folder" ? item?.title : item?.document_title,
    });
    setHoveredKey(null);
  };

  const handleFullscreenChange = () => {
    if (
      !document.fullscreenElement &&
      !document.webkitFullscreenElement &&
      !document.mozFullScreenElement &&
      !document.msFullscreenElement
    ) {
      handleEscapeKeyPress({ key: "Escape" });
    }
  };

  const handleEscapeKeyPress = (event) => {
    if (event?.key === "Escape") {
      setEsc(true);
    }
  };

  useEffect(() => {
    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [esc]);

  const onFolderPathClick = (node) => {
    if (node.document_file_name) {
      return;
    }
    setShowFilteredData(false);
    setSelectedKey(node?.id);
    const breadcrumbs = handleBreadcrumb(node, combinedResponse);
    setBreadcrumb(breadcrumbs);
    const selectedNodeDatas = findSelectedNode(combinedResponse, node?.id);
    setSelectedNodeData(selectedNodeDatas[0]);
    setResetNodeData(selectedNodeDatas[0]);
    setShowInnerFolder(true);
    const expandkey = checkParentKeyExist(node);
    setExpandedKeys(expandkey);
  };

  const filteredData = filtereData?.map((item) => ({
    document_file_name:
      item?.document_file_name || item?.folder_name ? item?.document_file_name || item?.folder_name : "-",
    path: item?.document_file_path ? (
      <a target="_blank" onClick={() => onFilterDocClick(item)} rel="noopener noreferrer">
        {item.document_file_path.split("generaldoctrol")[1]}
      </a>
    ) : (
      <a onClick={() => onFolderPathClick(item)}>{item?.path}</a>
    ),
    type: item?.document_file_name ? "File" : "Folder",
  }));

  const getParentToChildSearch = async (isReset) => {
    if (!search?.trim() && !isReset) {
      setShowFilteredData(false);
      return;
    }

    if (!isReset) {
      setVisibleCount(0);
      const visited = {};
      const searchResult = combinedResponse.filter(
        (node) =>
          (node.folder_name && node.folder_name.toLowerCase().includes(search.toLowerCase())) ||
          (node.document_file_name && node.document_file_name.toLowerCase().includes(search.toLowerCase()))
      );
      const filterParentObj = searchResult?.filter((item) => !item?.hasOwnProperty("document_file_name"));
      const findFolderPath = (obj, data) => {
        let path = [];
        while (obj && obj?.parent_id !== 0) {
          path.push(obj.folder_name);
          obj = data.find((item) => item.id === obj.parent_id);
        }
        if (obj) path.push(obj.folder_name);
        return path.reverse();
      };

      const result = filterParentObj.map((obj) => ({
        id: obj.id,
        path: "/" + findFolderPath(obj, combinedResponse).join("/"),
      }));

      const finalResult = searchResult?.map((item) => {
        const match = result?.find((itm) => itm?.id === item?.id);
        if (match) {
          return { ...item, path: match?.path };
        }
        return item;
      });
      setFilterData(finalResult);
      setShowFilteredData(true);
      setSpinLoader(false);
    } else {
      setSelectedNodeData(resetNodeData);
    }
  };

  // sorting reset
  const closeAllFunc = () => {
    setSelectedNodeData(null);
    setExpandedKeys([]);
    setVisibleCount(0);
    setBreadcrumb([]);
  };

  const sortingReset = () => {
    getParentToChildSearch(false);
    setSearch("");
    setPageSize(50);
    if (search) {
      fetchBriefFolderList(selectedKey);
      setVisibleCount(0);
    }
  };

  const breadcrumbNavigation = (val) => {
    const findData = combinedResponse?.find((value) => value?.id === val);
    setSelectedKey(findData?.id);
    const breadcrumbs = handleBreadcrumb(findData, combinedResponse, "reverse");
    setBreadcrumb(breadcrumbs);
    const selectedNodeDatas = findSelectedNode(combinedResponse, findData?.id);
    setSelectedNodeData(selectedNodeDatas[0]);
  };

  const handleBack = () => {
    if (breadcrumb.length > 1) {
      const reduceBy = backClickCount === 0 ? 1 : 2;
      const updatedBreadcrumb = breadcrumb.slice(0, -reduceBy);

      const backIndex = breadcrumb.length - reduceBy;
      const backData = breadcrumb[backIndex];

      const convertString = typeof backData === "string" ? backData : JSON.stringify(backData);

      setBreadcrumb(updatedBreadcrumb);
      breadcrumbNavigation(convertString);
      setBackClickCount((prev) => prev + 1);
    } else if (breadcrumb?.length === 1) {
      breadcrumbNavigation(breadcrumb[0]);
      setBackClickCount(0);
    } else if (breadcrumb?.length === 0) {
      setBackClickCount(0);
      return;
    } else {
      setBackClickCount(0);
      return;
    }
  };

  useEffect(() => {
    if (!selectedNodeData) {
      const generalDocNode = findNodeByKey(treeDataLeft, "0-0");
      setSelectedNodeData(generalDocNode);
      setShowInnerFolder(true);
    }
  }, [treeDataLeft, selectedNodeData]);

  const handleClose = () => {
    setUploadDocModal(false);
  };

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
      setUploadingFolder(true);
    }
  };

  const handleFolderUpload = async (e) => {
    e.preventDefault();
    try {
      const files = Array.from(fileInputRef.current.files);

      if (files.length === 0) {
        return;
      }

      const tree = {};

      const formData = new FormData();
      formData.append("folder_id", selectedKey);
      let counter = 0;

      files.forEach((file) => {
        formData.append("files", file);

        const pathParts = file.webkitRelativePath.split("/");
        const relativePath = pathParts.slice(0, -1).join("/");
        formData.append(`paths-${++counter}-${file.name}`, relativePath);
      });
      try {
        const response = await axios.post(`${DocBaseUrl}/folder-upload`, formData, {
          headers: {
            Authorization: localStorage.getItem("docGridToken"),
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          },
        });
        if (response?.data?.status == 1) {
          fetchBriefFolderList(selectedKey);
          setUploadingFolder(false);
          setUploadDocModal(false);
          notifySuccess("Folder Uploaded Successfully");
        } else {
          notify("Folder Upload Failed");
          setUploadingFolder(false);
        }
      } catch (error) {
        notify("Folder Upload Failed");
        setUploadingFolder(false);
      }
    } catch (error) {
      console.error("Upload error:", error);
    }
  };

  const [showCount, setShowCount] = useState(false);
  const handleScroll = () => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    const scrollTop = scrollContainer.scrollTop;
    const clientHeight = scrollContainer.clientHeight;

    // Get row height
    const rowElement = scrollContainer.querySelector(".grid__wrapper > div");
    const rowHeight = rowElement ? rowElement.offsetHeight : 100;

    // Calculate rows visible in the viewport
    const rowsVisible = Math.floor(clientHeight / rowHeight);

    // Get column count from grid-template-columns
    const gridWrapper = scrollContainer.querySelector(".grid__wrapper");
    const columnCount = parseInt(
      getComputedStyle(gridWrapper).getPropertyValue("grid-template-columns").split(" ").length,
      10
    );

    // Scrolled rows
    const scrolledRows = Math.floor(scrollTop / rowHeight);
    const totalVisibleCount = (scrolledRows + rowsVisible) * columnCount;

    // Total items
    const totalItems = selectedNodeData?.children?.filter((item) => item?.title !== ".db").length || 0;
    const visibleCountToSet = Math.min(totalVisibleCount, totalItems);
    setVisibleCount(visibleCountToSet);

    if (scrollTop > 10) {
      setShowCount(true);
    } else {
      setShowCount(false);
    }
  };

  const handleImagesLoaded = () => {
    // Trigger scroll calculation after images have finished loading
    handleScroll();
  };

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);

      const images = scrollContainer.querySelectorAll("img");
      let imagesLoaded = 0;

      images.forEach((img) => {
        if (img.complete) {
          imagesLoaded++;
        } else {
          img.addEventListener("load", () => {
            imagesLoaded++;
            if (imagesLoaded === images.length) {
              handleImagesLoaded();
            }
          });
        }
      });
      handleScroll();
      return () => {
        scrollContainer.removeEventListener("scroll", handleScroll);
      };
    }
  }, [selectedNodeData?.children, zoomLevel]);

  const totalCountDataFun = async (id) => {
    const formData = new URLSearchParams();
    formData.append("folder_id", id || "");
    try {
      const response = await request("/folder-files-count", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status === "1") {
        setTotalCountData(response?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!selectedNodeData) {
      totalCountDataFun();
    }
  }, []);

  const handleSearchFun = (value) => {
    setSearch(value);
  };

  const handleBodyScroll = () => {
    const container = scrollRef.current;
    const lastElement = document.getElementById("imgCaseId");

    if (container && lastElement) {
      const containerBottom = container.scrollTop + container.clientHeight;
      const lastElementTop = lastElement.offsetTop;

      if (containerBottom >= lastElementTop && currentPage < totalData?.totalPages) {
        clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
          setCurrentPage((prev) => prev + 1);
          setCallApi(true);
        }, 300);
      }
    }
  };

  useEffect(() => {
    if (selectedNodeData?.children) {
      const container = scrollRef.current;
      if (container) {
        container.addEventListener("scroll", handleBodyScroll);
      }
      return () => {
        if (container) {
          container.removeEventListener("scroll", handleBodyScroll);
        }
      };
    }
  }, [currentPage, totalData?.totalPages, selectedNodeData?.children]);

  const menu = (
    <Menu
      items={[
        { key: "1", label: "Option 1" },
        { key: "2", label: "Option 2" },
        { key: "3", label: "Option 3" },
      ]}
    />
  );

  const onNodeHover = (key) => {
    setHoveredKey(key);
  };

  const onNodeLeave = () => {
    setHoveredKey(null);
  };

  const handleCreateModelOpen = (slug) => {
    setFolderSlug(slug);
    setBasicModal(true);
  };

  const handleFav = async (item) => {
    const updatedChildren = selectedNodeData?.children?.map((child) => {
      if (child.key === item.key) {
        return { ...child, is_fav: !child.is_fav };
      }
      return child;
    });
    setSelectedNodeData((prev) => ({
      ...prev,
      children: updatedChildren,
    }));
    const formData = new URLSearchParams();
    item?.type === "folder" ? formData.append("folder_ids", item.key) : formData.append("file_ids", item.key);

    try {
      const response = await request("/favorite", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });
      if (response?.data?.status === "1") {
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onIdGet = () => {
    setSelectedKey(selectedNodeData?.key);
  };

  useEffect(() => {
    const handleKeyDownCopy = (event) => {
      if (event.ctrlKey && event.key === "c" && selectedItems.length > 0) {
        event.preventDefault();
        const copiedText = selectedItems.map((item) => item.document_title || item.title);
        navigator.clipboard
          .writeText(copiedText.join("\n"))
          .then(() => {
            const newFileIDs = [];
            const newFolderIDs = [];

            selectedItems.forEach((item) => {
              if (item.document_file_name) {
                newFileIDs.push(item.key); // It's a file, so store its ID
              } else {
                newFolderIDs.push(item.key); // It's a folder, so store its ID
              }
            });
            setFileIDs(newFileIDs);
            setFolderIDs(newFolderIDs);
          })
          .catch((err) => console.error("Copy failed", err));
      }
    };
    window.addEventListener("keydown", handleKeyDownCopy);
    return () => {
      window.removeEventListener("keydown", handleKeyDownCopy);
    };
  }, [selectedItems]);

  const processedChildren = selectedNodeData?.children?.map((child) => ({
    ...child,
    type: child.document_file_name ? "file" : "folder",
  }));

  useEffect(() => {
    const handleKeyDownSelectAll = (event) => {
      if (event.ctrlKey && event.key === "a") {
        event.preventDefault(); // Prevent default "Select All" behavior
        if (processedChildren?.length > 0) {
          setSelectedItems([...processedChildren]); // Select all files & folders in the current directory
        }
      }
    };

    window.addEventListener("keydown", handleKeyDownSelectAll);
    return () => {
      window.removeEventListener("keydown", handleKeyDownSelectAll);
    };
  }, [processedChildren]);

  const handleItemClick = (e, child) => {
    if (e.target.type === "checkbox" || e.target.closest(".ant-checkbox-wrapper")) {
      return;
    }
    e.preventDefault();
    setTimeout(() => {
      setSelectedItems((prevSelected) => {
        const isAlreadySelected = prevSelected.some((item) => item.key === child.key && item.type === child.type);
        if (e.ctrlKey || e.metaKey) {
          return isAlreadySelected
            ? prevSelected.filter((item) => !(item.key === child.key && item.type === child.type))
            : [...prevSelected, child];
        } else {
          return [child];
        }
      });
    }, 200);
  };

  const handleRightClick = (e, child) => {
    const filterData = selectedItems?.find((item) => item?.key === child.key);
    if (!filterData && selectedItems?.length > 1) {
      e.preventDefault();
      handleItemClick(e, child);
    }
  };

  const handlePaste = async (targetFolderId = selectedKey, filesToMove = moveFilesIds, slug = moveSlug) => {
    const formData = new URLSearchParams();
    formData.append("targetFolderId", targetFolderId);

    if (Array.isArray(filesToMove)) {
      // Separate files and folders
      const files = filesToMove.filter((item) => item.type === "file");
      const folders = filesToMove.filter((item) => item.type === "folder");

      // Append multiple files
      files.forEach((file) => {
        formData.append("files_ids", file.key);
      });

      // Append multiple folders
      folders.forEach((folder) => {
        formData.append("folder_ids", folder.key);
      });
    } else if (filesToMove) {
      // Single item case
      if (filesToMove.type === "file") {
        formData.append("files_ids", filesToMove.key);
      } else if (filesToMove.type === "folder") {
        formData.append("folder_ids", filesToMove.key);
      }
    }

    try {
      const response =
        slug == "move"
          ? await request("/move", "post", formData, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          : await request("/copy-paste", "post", formData, {
            "Content-Type": "application/x-www-form-urlencoded",
          });

      if (response?.data?.status == "1") {
        setSelectedItems([]);

        fetchBriefFolderList(selectedKey);
        setMoveFilesIds([]);
        setMoveSlug("");
      }
    } catch (error) {
      console.log(error, "error while pasting");
    }
  };
  useEffect(() => {
    const handleKeyDownpaste = async (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === "v") {
        event.preventDefault();
        handlePaste();
      }
    };
    window.addEventListener("keydown", handleKeyDownpaste);
    return () => {
      window.removeEventListener("keydown", handleKeyDownpaste);
    };
  }, [selectedKey]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectAllCheckboxRef.current && selectAllCheckboxRef.current.contains(event.target)) {
        return;
      }
      if (folderRef.current && !folderRef.current.contains(event.target)) {
        setSelectedItems([]);
      }
    };
    document.addEventListener("click", handleClickOutside);
    document.addEventListener("dblclick", handleClickOutside);
    document.addEventListener("contextmenu", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("dblclick", handleClickOutside);
      document.removeEventListener("contextmenu", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (selectedItems.length > 1) {
      const folder = selectedItems?.find((item) => item?.type === "folder");
      const files = selectedItems?.find((item) => item?.type === "file");
      folder && files
        ? setSelectedType("both")
        : folder && !files
          ? setSelectedType("folder")
          : setSelectedType("file");
    }
  }, [selectedItems]);

  const handleMoveFiles = (data, slug) => {
    setMoveFilesIds(data);
    setMoveSlug(slug);
  };

  const handleShareFiles = async (data, slug) => {
    setShareFileOpen(true);
    const ids = data?.length > 1 ? data.map((obj) => obj.key).join(",") : data?.key;
    try {
      const formData = new URLSearchParams();
      formData.append("fileIds", ids);
      const response = await request("/share-link", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });
      if (response?.data?.status == 1) {
        setShareLink(response?.data?.link);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleLockFolder = (data, slug) => {
    setLockOpen(true);
    setProtectedLockData(data);
    setProtectedSlug(slug);
  };

  // useEffect(() => {
  //   const handleClickOutside = (e) => {
  //     const unlocked = sessionStorage.getItem("unlockedFolders");
  //     if (unlocked && folderRef.current && !folderRef.current.contains(e.target)) {
  //       setExpandedKeys((prevKeys) => prevKeys.filter((key) => !unlocked.includes(key)));
  //       sessionStorage.removeItem("unlockedFolders");
  //       console.log("Session storage cleared");
  //     }
  //   };

  //   document.addEventListener("click", handleClickOutside);

  //   return () => {
  //     document.removeEventListener("click", handleClickOutside);
  //   };
  // }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      sessionStorage.removeItem("unlockedFolders");
    }, 2 * 60 * 1000); // lock after 2 minutes

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    socket.on("connect", () => {
      console.log("Connected to socket server:");
    });

    socket.on("disconnect", () => {
      console.log(" Disconnected from socket server");
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    socket.on("user-count", (users) => {
      setActiveUserCount(users);
    });

    return () => {
      socket.off("user-count");
    };
  }, [selectedKey]);

  const getInitials = (name) => {
    if (!name) return "";
    return name
      .split(" ")
      .map((word) => word[0]?.toUpperCase())
      .join("");
  };

  // Inline menu function
  const renderUserMenu = () => (
    <Menu>
      {activeUserCount?.users?.map((user) => (
        <Menu.Item key={user.userId}>
          <Space>
            <Avatar style={{ backgroundColor: "#87d068" }}>{getInitials(user.userName)}</Avatar>
            <span>{user.userName}</span>
          </Space>
        </Menu.Item>
      ))}
    </Menu>
  );

  const fetchFolderItems = async (folderId) => {
    const formData = new URLSearchParams();
    formData.append("folder_id", folderId || "");
    const response = await request("/doctrol-files-list", "post", formData, {
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return response?.data?.status === "1" ? response.data.data : [];
  };

  const filterDataFromFolder = async () => {
    if (!folderSearch?.trim()) {
      setShowFilteredData(false);
      return;
    }

    const searchQuery = folderSearch.toLowerCase();

    // Recursive async function to search through nested folders
    const recursiveSearch = async (nodes, currentPath = "/") => {
      let results = [];

      for (const node of nodes) {
        // Match by title or file name
        const titleMatch =
          node.title?.toLowerCase().includes(searchQuery) ||
          node.document_file_name?.toLowerCase().includes(searchQuery);

        console.log(node.document_file_path)
        if (titleMatch) {
          results.push({
            id: node.key,
            document_file_name: node.document_title || node.title,
            path: node?.document_file_path ? (
              <a
                target="_blank"
                onClick={() =>
                  onFilterDocClick({
                    ...node,
                    path: currentPath + node.title + "/",
                    id: node.id,
                  })
                }
                rel="noopener noreferrer"
              >
                {node.document_file_path}
              </a>

            ) : (
              <a
                onClick={() =>
                  onFolderPathClick({
                    ...node,
                    path: currentPath + node.title + "/",
                    id: node.key,
                  })
                }
              >
                {currentPath + node.title + '/'}
              </a>
            ),
            type: node?.document_file_name ? "File" : "Folder",
          });
        }

        // Fetch folder items dynamically if it's a folder
        let folderItems = [];
        if (!node.document_file_name) {
          folderItems = await fetchFolderItems(node.key); // ✅ properly awaited
        }

        if ((node.children && node.children.length > 0) || folderItems.length > 0) {
          const childResults = await recursiveSearch(
            [...(node.children || []), ...folderItems],
            currentPath + node.title + "/"
          );
          results = results.concat(childResults);
        }
      }

      return results;
    };

    // Start recursive search
    const result = await recursiveSearch(selectedNodeData?.children || []);

    setFilterData(result);
    setShowFilteredData(true);
  };

  const handleRightClickPaste = (event) => {
    event.preventDefault(); // stop the browser's menu
    setContextMenu({
      x: event.clientX,
      y: event.clientY,
    });
  };

  const handleClickOutside = () => {
    setContextMenu(null);
  };

  useEffect(() => {
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  // const handleMoves = async (targeted_folder, Ids_to_move) => {
  //   setSelectedKey(targeted_folder.key);
  //   setMoveFilesIds(Ids_to_move);
  //   setMoveSlug("move");
  //   handlePaste(targeted_folder.key, Ids_to_move, "move");
  // };

  useEffect(() => {
    const title = selectedNodeData?.title ? `Docs Grid | ${selectedNodeData.title}` : "Docs Grid";
    document.title = title;
  }, [selectedNodeData]);

  const checkAll = processedChildren?.length === selectedItems?.length;

  return (
    <>
      {contextMenu && hasPasteItems && (
        <div
          style={{
            position: "absolute",
            top: contextMenu.y,
            left: contextMenu.x,
            background: "#fff",
            border: "1px solid #ccc",
            padding: "8px",
            borderRadius: "4px",
            zIndex: 9999,
            cursor: "pointer",
          }}
          onClick={() => {
            handlePaste();
            setContextMenu(null);
          }}
        >
          Paste
        </div>
      )}
      <div className="bd_document_warpper">
        <div className="bd_doc_folder" id="zoom">
          <div className="bd_doc_folder">
            <div className="nt_head">
              <div className="d-flex">
                <div className="goBack_btn" onClick={() => handleBack()}>
                  <LeftTwo theme="filled" size="24" fill="#2a2a2b" strokeWidth={1} strokeLinecap="butt" />
                </div>
                {userInfo?.permanent_sys_adm == "1" && (
                  <div className="newFolder_btn user_activity" onClick={() => handleCreateModelOpen("outer")}>
                    <FolderPlus theme="outline" size="22	" strokeWidth={3} strokeLinecap="butt" />
                    <p className="user_activity_para">New folder</p>
                  </div>
                )}
                <input
                  id="folder-input"
                  type="file"
                  webkitdirectory="true"
                  directory=""
                  multiple
                  ref={fileInputRef}
                  onChange={handleFolderUpload}
                  style={{ display: "none" }}
                  className="hidden"
                />
                {selectedNodeData && (
                  <>
                    <div className="user_activity" onClick={() => handleShowDataAcc("image")}>
                      <FileImageOutlined />
                      <p className="user_activity_para"> Images</p>
                    </div>

                    <div className="user_activity" onClick={() => handleShowDataAcc("video")}>
                      <VideoCameraOutlined />
                      <p className="user_activity_para"> Videos</p>
                    </div>
                    <div className="closeFolder user_activity" onClick={() => closeAllFunc()}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19"
                        height="19"
                        fill="currentColor"
                        className="bi bi-dash-square"
                        viewBox="0 0 16 16"
                        strokeWidth={3}
                      >
                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8" />
                      </svg>

                      <p className="user_activity_para">Close all</p>
                    </div>
                    <div className="user_activity" onClick={() => handleShowDataAcc("recent")}>
                      <ClockCircleOutlined />
                      <p className="user_activity_para"> Recent</p>
                    </div>
                  </>
                )}
              </div>
              <div className="nth_right">
                {selectedNodeData && (
                  <>
                    {/* <div className="search_docItem">
                      <Input
                        type="text"
                        onChange={(e) => {
                          const value = e.target.value;
                          handleSearchFun(value);
                          if (!value) {
                            setShowFilteredData(false);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            getParentToChildSearch(false);
                          }
                        }}
                        value={search}
                        placeholder="Search here"
                        style={{ width: "280px", border: "none" }}
                        allowClear
                      />
                      <Button onClick={() => getParentToChildSearch(false)}>
                        <Search theme="outline" size="22" fill="#98a1b3" strokeWidth={3} strokeLinecap="butt" />
                      </Button>
                    </div> */}
                    <Select
                      style={{
                        minWidth: 150,
                      }}
                      placeholder="Sort By"
                      onChange={handleZoomdropdown}
                      options={sortingOption}
                      value={sortingOption.find((option) => option.zoom === zoomLevel)?.value}
                      getPopupContainer={() => document.getElementById("zoom")}
                    />
                  </>
                )}
                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  {selectedNodeData && (
                    <Button className="BG_ghostButton" onClick={sortingReset}>
                      {" "}
                      Reset
                    </Button>
                  )}
                  {isIdpMode && (
                    <Tooltip placement="bottom" title="All apps">
                      <a className="bd_appsLauncher" href={ssoAppsUrl} aria-label="All apps">
                        <AppsIcon />
                      </a>
                    </Tooltip>
                  )}
                  <UserProfile />
                </div>
              </div>
            </div>
            <Splitter style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)" }} ref={unLockedRef}>
              <Splitter.Panel defaultSize="18%" min="15%" max="24%">
                <div className="nestTree_wrap">
                  <DirectoryTree
                    selectedKeys={[selectedNodeData?.key]}
                    multiple
                    onSelect={onSelect}
                    treeData={treeDataLeft}
                    onExpand={onExpand}
                    expandedKeys={expandedKeys}
                    titleRender={
                      renameLabel &&
                      ((nodeData) => (
                        <div
                          onMouseEnter={() => onNodeHover(nodeData.key)}
                          onMouseLeave={onNodeLeave}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            paddingRight: "10px",
                            position: "relative",
                          }}
                        >
                          <span style={{ whiteSpace: "nowrap" }}>{nodeData.title}</span>
                          {(hoveredKey === nodeData.key || selectedNodeData?.key === nodeData.key) && (
                            <Dropdown
                              menu={{
                                items: [
                                  renameLabel && {
                                    label: renameLabel,
                                    key: "1",
                                    onClick: () => handleRenameFolder(nodeData, "folder"),
                                  },
                                ].filter(Boolean),
                              }}
                              getPopupContainer={() => document.getElementById("zoom")}
                              trigger={["hover"]}
                            >
                              <span
                                style={{
                                  cursor: "pointer",
                                  color: "#222",
                                  padding: "0 8px",
                                  fontSize: "20px",
                                  fontWeight: "bold",
                                  position: "absolute",
                                  right: "-80px",
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                &#x22EE;
                              </span>
                            </Dropdown>
                          )}
                        </div>
                      ))
                    }
                  />
                </div>
              </Splitter.Panel>
              <Splitter.Panel>
                <div
                  style={{
                    height: "100%",
                    background: "linear-gradient(to bottom right, #f8fafc, #f1f5f9)",
                  }}
                >
                  {!selectedNodeData?.key ? (
                    <Dashboard />
                  ) : !showFilteredData ? (
                    <div className="innerFolder" style={showInnerFolder ? { display: "block" } : { display: "none" }}>
                      {showDataAcc.length == [] && (
                        <div className="inner_head">
                          <div className="breadcrumb_wrap">
                            {breadcrumb?.map((val, index) => {
                              return (
                                <>
                                  <div
                                    key={index}
                                    className="bw_item"
                                    onClick={() => breadcrumbNavigation(val.folderId)}
                                  >
                                    {val.folderName}
                                    <Right
                                      theme="outline"
                                      size="18"
                                      fill="#98a1b3"
                                      strokeWidth={3}
                                      strokeLinecap="butt"
                                    />
                                  </div>
                                </>
                              );
                            })}
                            {!breadcrumbSlug && <div className="bw_item_active">{selectedNodeData?.title}</div>}
                          </div>

                          <div>
                            {downloading && (
                              <Progress
                                percent={downloadingProgress}
                                status="active"
                                format={(percent) => `${percent}% Downloading...`}
                              />
                            )}
                          </div>

                          <div className="d-flex">
                            {selectedNodeData && selectedNodeData.children?.length > 0 && (
                              <div ref={selectAllCheckboxRef}>
                                {
                                  <Checkbox
                                    checked={checkAll}
                                    indeterminate={selectedItems.length > 0 && !checkAll}
                                    onChange={(e) => {
                                      e.stopPropagation();
                                      if (e.target.checked) {
                                        setSelectedItems([...processedChildren]);
                                      } else {
                                        setSelectedItems([]);
                                      }
                                    }}
                                  >
                                    Select All
                                  </Checkbox>
                                }
                              </div>
                            )}

                            <Input
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  filterDataFromFolder();
                                }
                              }}
                              onChange={(e) => {
                                const value = e.target.value;
                                setFolderSearch(value);
                              }}
                              style={{ width: "270px" }}
                              value={folderSearch}
                              placeholder="Search here"
                            />
                            {activeUserCount?.users?.length > 1 && (
                              <div>
                                <Dropdown overlay={renderUserMenu()} trigger={["click"]}>
                                  <Space size={24} style={{ cursor: "pointer" }}>
                                    <Badge count={activeUserCount?.count}>
                                      <Avatar shape="circle" icon={<UserOutlined />} />
                                    </Badge>
                                  </Space>
                                </Dropdown>
                              </div>
                            )}

                            {outerPermission && (
                              <>
                                <Dropdown
                                  menu={{
                                    items: [
                                      {
                                        key: "1",
                                        label: <div onClick={() => setOpenFileCreate(true)}>File</div>,
                                      },
                                      {
                                        key: "2",
                                        label: <div onClick={() => handleCreateModelOpen("inner")}>Folder</div>,
                                      },
                                    ],
                                  }}
                                  placement="bottom"
                                >
                                  <Button className="BG_mainButton">
                                    <PlusOutlined style={{ fontSize: "16px" }} />
                                    New
                                  </Button>
                                </Dropdown>

                                <Button className="BG_mainButton" onClick={() => setUploadDocModal(true)}>
                                  {" "}
                                  <UploadOutlined style={{ fontSize: "16px" }} />
                                  Upload
                                </Button>
                              </>
                            )}
                          </div>
                        </div>
                      )}

                      {!spinLoader ? (
                        <>
                          {selectedNodeData && selectedNodeData.children?.length > 0 ? (
                            <>
                              <div
                                onClick={onIdGet}
                                ref={scrollRef}
                                id="content"
                                className="inner_body"
                                onContextMenu={handleRightClickPaste}
                              >
                                <div
                                  className={showDataAcc?.length > 0 ? "normal_wrapper grid__wrapper" : "grid__wrapper"}
                                  ref={folderRef}
                                  style={{
                                    gridTemplateColumns: `repeat(${zoomLevel}, minmax(0, 1fr))`,
                                    height: `${gridHeight}px`,
                                  }}
                                >
                                  {(showDataAcc?.length > 0 ? showDataAcc : processedChildren)?.map((child, i) => {
                                    return (
                                      <div
                                        className={`item-class relative ${selectedItems.some(
                                          (item) => item.key === child.key && item.type === child.type
                                        )
                                          ? "selected"
                                          : ""
                                          }`}
                                        key={child.key && `${child.key}-${child.type}`}
                                        ref={unLockedRef}
                                        onClick={(e) => showDataAcc?.length == 0 && handleItemClick(e, child)}
                                        onContextMenu={(e) => showDataAcc?.length == 0 && handleRightClick(e, child)}
                                        style={{
                                          backgroundColor: selectedItems.some(
                                            (item) => item.key === child.key && item.type === child.type
                                          )
                                            ? "#d3d3d3"
                                            : "transparent",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {showDataAcc?.length > 0 ? (
                                          <>
                                            <ShowImage key={child?.id} showDataAcc={child} fileType={fileType} />
                                          </>
                                        ) : (
                                          <>
                                            <Tooltip title={child?.document_title}>
                                              <div className="users_icons">
                                                <div className="icons">
                                                  <Checkbox
                                                    onClick={(e) => e.stopPropagation()}
                                                    style={{
                                                      border: "black",
                                                    }}
                                                    checked={selectedItems.some(
                                                      (item) => item.key === child.key && item.type === child.type
                                                    )}
                                                    onChange={(e) => {
                                                      if (e.target.checked) {
                                                        setSelectedItems((prev) => [...prev, child]);
                                                      } else {
                                                        setSelectedItems((prev) =>
                                                          prev.filter(
                                                            (item) =>
                                                              !(item.key === child.key && item.type === child.type)
                                                          )
                                                        );
                                                      }
                                                    }}
                                                  />
                                                </div>

                                                <div className="icons">
                                                  <div style={{ display: "flex", gap: "4px" }}>
                                                    <div>
                                                      {" "}
                                                      {child?.is_fav ? (
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="16"
                                                          height="16"
                                                          fill="currentColor"
                                                          className="bi bi-bookmark-fill"
                                                          viewBox="0 0 16 16"
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleFav(child);
                                                          }}
                                                          style={{
                                                            fontSize: "18px",
                                                            color: "black",
                                                          }}
                                                        >
                                                          <path d="M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2" />
                                                        </svg>
                                                      ) : (
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="16"
                                                          height="16"
                                                          fill="currentColor"
                                                          className="bi bi-bookmark"
                                                          viewBox="0 0 16 16"
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleFav(child);
                                                          }}
                                                          style={{
                                                            fontSize: "18px",
                                                            color: "black",
                                                          }}
                                                        >
                                                          <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z" />{" "}
                                                        </svg>
                                                      )}
                                                    </div>
                                                    {
                                                      <>
                                                        {child?.commit_count > 0 ? (
                                                          <Badge count={child?.commit_count} size="small">
                                                            <CommentOutlined
                                                              onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleAddCommentList(child);
                                                              }}
                                                              style={{
                                                                fontSize: "18px",
                                                                color: "black",
                                                              }}
                                                            />
                                                          </Badge>
                                                        ) : (
                                                          <CommentOutlined
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              handleAddCommentList(child);
                                                            }}
                                                            style={{
                                                              fontSize: "18px",
                                                              color: "black",
                                                            }}
                                                          />
                                                        )}
                                                      </>
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                              <RightBrief
                                                node={child}
                                                isLastElement={processedChildren?.length == i + 1}
                                                handleItemClick={handleItemClick}
                                                Permission={Permission}
                                                setSelectedKey={setSelectedKey}
                                                combinedResponse={combinedResponse}
                                                setBreadcrumb={setBreadcrumb}
                                                breadcrumb={breadcrumb}
                                                setSelectedNodeData={setSelectedNodeData}
                                                setResetNodeData={setResetNodeData}
                                                setShowInnerFolder={setShowInnerFolder}
                                                expandedKeys={expandedKeys}
                                                setExpandedKeys={setExpandedKeys}
                                                handleDeleteModal={handleDeleteModal}
                                                handleRenameFolder={handleRenameFolder}
                                                selectedType={selectedType}
                                                selectedItems={selectedItems}
                                                setDownloading={setDownloading}
                                                setDownloadingProgress={setDownloadingProgress}
                                                handleMoveFiles={handleMoveFiles}
                                                handleShareFiles={handleShareFiles}
                                                handleLockFolder={handleLockFolder}
                                                setLockOpen={setLockOpen}
                                                // handleRecentTracker={handleRecentTracker}
                                                setProtectedSlug={setProtectedSlug}
                                                setProtectedLockData={setProtectedLockData}
                                                userInfo={userInfo}
                                                socket={socket}
                                              />
                                            </Tooltip>
                                          </>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="noFound_wrapper" onContextMenu={handleRightClickPaste}>
                              <img src={noFoundImg} alt="img" loading="lazy" />
                              Folder is empty
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="bd_doc_folder treeSpinner">
                            {" "}
                            <Spin size="large" />
                          </div>
                        </>
                      )}
                      <div
                        style={{
                          position: "absolute",
                          bottom: 0,
                          width: "100%",
                          right: "0",
                          zIndex: "99",
                        }}
                      >
                        <Col
                          span={24}
                          style={{
                            backgroundColor: "#fff",
                            borderTop: "1px solid #e2e8f0",
                            paddingBlock: "8px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              margin: "0px 10px ",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <div style={{ display: "flex", gap: "5px" }}>
                                <span>Total Files :</span>
                                <p>{totalCountData?.totalFilesCount}</p>
                              </div>
                              <div style={{ display: "flex" }}>
                                <span>Total Folder :</span>
                                <p>{totalCountData?.totalFoldersCount}</p>
                              </div>

                              {totalCountData?.modifier && (
                                <div style={{ display: "flex" }}>
                                  <span>Modified By :</span>
                                  <p>{totalCountData?.modifier}</p>
                                </div>
                              )}
                            </div>
                            <div>
                              <div style={{ display: "flex", gap: "6px" }}>
                                <span>{selectedNodeData ? "Last Update:" : "Last Login:"}</span>
                                <p>
                                  {selectedNodeData
                                    ? dayjs(totalCountData?.last_update).format("YYYY-MM-DD h:mm A")
                                    : dayjs(totalCountData?.last_login).format("YYYY-MM-DD h:mm A")}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div>
                        <h3 style={{ color: "black", padding: "15px" }}>Searched Data</h3>
                        <div style={{ padding: "15px" }}>
                          <Table columns={columns} dataSource={filteredData} bordered pagination={{ pageSize: 7 }} />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </Splitter.Panel>
            </Splitter>
            {/* <Row ref={unLockedRef} gutter={0}>
              <Col span={4}>
             
              </Col>
              <Col
                span={20}
                style={{
                  background: "linear-gradient(to bottom right, #f8fafc, #f1f5f9)",
                }}
              >
                {!selectedNodeData?.key ? (
                  <Dashboard />
                ) : !showFilteredData ? (
                  <div className="innerFolder" style={showInnerFolder ? { display: "block" } : { display: "none" }}>
                    {showDataAcc.length == [] && (
                      <div className="inner_head">
                        <div className="breadcrumb_wrap">
                          {breadcrumb?.map((val, index) => {
                            return (
                              <>
                                <div key={index} className="bw_item" onClick={() => breadcrumbNavigation(val.folderId)}>
                                  {val.folderName}
                                  <Right
                                    theme="outline"
                                    size="18"
                                    fill="#98a1b3"
                                    strokeWidth={3}
                                    strokeLinecap="butt"
                                  />
                                </div>
                              </>
                            );
                          })}
                          {!breadcrumbSlug && <div className="bw_item_active">{selectedNodeData?.title}</div>}
                        </div>

                        <div>
                          {downloading && (
                            <Progress
                              percent={downloadingProgress}
                              status="active"
                              format={(percent) => `${percent}% Downloading...`}
                            />
                          )}
                        </div>

                        <div className="d-flex">
                          {selectedNodeData && selectedNodeData.children?.length > 0 && (
                            <div ref={selectAllCheckboxRef}>
                              {
                                <Checkbox
                                  checked={checkAll}
                                  indeterminate={selectedItems.length > 0 && !checkAll}
                                  onChange={(e) => {
                                    e.stopPropagation();
                                    if (e.target.checked) {
                                      setSelectedItems([...processedChildren]);
                                    } else {
                                      setSelectedItems([]);
                                    }
                                  }}
                                >
                                  Select All
                                </Checkbox>
                              }
                            </div>
                          )}

                          <Input
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                filterDataFromFolder();
                              }
                            }}
                            onChange={(e) => {
                              const value = e.target.value;
                              setFolderSearch(value);
                            }}
                            style={{ width: "270px" }}
                            value={folderSearch}
                            placeholder="Search here"
                          />
                          {activeUserCount?.users?.length > 1 && (
                            <div>
                              <Dropdown overlay={renderUserMenu()} trigger={["click"]}>
                                <Space size={24} style={{ cursor: "pointer" }}>
                                  <Badge count={activeUserCount?.count}>
                                    <Avatar shape="circle" icon={<UserOutlined />} />
                                  </Badge>
                                </Space>
                              </Dropdown>
                            </div>
                          )}

                          {outerPermission && (
                            <>
                              <Dropdown
                                menu={{
                                  items: [
                                    {
                                      key: "1",
                                      label: <div onClick={() => setOpenFileCreate(true)}>File</div>,
                                    },
                                    {
                                      key: "2",
                                      label: <div onClick={() => handleCreateModelOpen("inner")}>Folder</div>,
                                    },
                                  ],
                                }}
                                placement="bottom"
                              >
                                <Button className="BG_mainButton">
                                  <PlusOutlined style={{ fontSize: "16px" }} />
                                  New
                                </Button>
                              </Dropdown>

                              <Button className="BG_mainButton" onClick={() => setUploadDocModal(true)}>
                                {" "}
                                <UploadOutlined style={{ fontSize: "16px" }} />
                                Upload
                              </Button>
                            </>
                          )}
                        </div>
                      </div>
                    )}

                    {!spinLoader ? (
                      <>
                        {selectedNodeData && selectedNodeData.children?.length > 0 ? (
                          <>
                            <div
                              onClick={onIdGet}
                              ref={scrollRef}
                              id="content"
                              className="inner_body"
                              onContextMenu={handleRightClickPaste}
                            >
                              <div
                                className={showDataAcc?.length > 0 ? "normal_wrapper grid__wrapper" : "grid__wrapper"}
                                ref={folderRef}
                                style={{
                                  gridTemplateColumns: `repeat(${zoomLevel}, minmax(0, 1fr))`,
                                  height: `${gridHeight}px`,
                                }}
                              >
                                {(showDataAcc?.length > 0 ? showDataAcc : processedChildren)?.map((child, i) => {
                                  return (
                                    <div
                                      className={`item-class relative ${
                                        selectedItems.some((item) => item.key === child.key && item.type === child.type)
                                          ? "selected"
                                          : ""
                                      }`}
                                      key={child.key && `${child.key}-${child.type}`}
                                      ref={unLockedRef}
                                    image.jpeg
  onClick={(e) => showDataAcc?.length == 0 && handleItemClick(e, child)}
                                      onContextMenu={(e) => showDataAcc?.length == 0 && handleRightClick(e, child)}
                                      style={{
                                        backgroundColor: selectedItems.some(
                                          (item) => item.key === child.key && item.type === child.type
                                        )
                                          ? "#d3d3d3"
                                          : "transparent",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {showDataAcc?.length > 0 ? (
                                        <>
                                          <ShowImage key={child?.id} showDataAcc={child} fileType={fileType} />
                                        </>
                                      ) : (
                                        <>
                                          <Tooltip title={child?.document_title}>
                                            <div className="users_icons">
                                              <div className="icons">
                                                <Checkbox
                                                  onClick={(e) => e.stopPropagation()}
                                                  style={{
                                                    border: "black",
                                                  }}
                                                  checked={selectedItems.some(
                                                    (item) => item.key === child.key && item.type === child.type
                                                  )}
                                                  onChange={(e) => {
                                                    if (e.target.checked) {
                                                      setSelectedItems((prev) => [...prev, child]);
                                                    } else {
                                                      setSelectedItems((prev) =>
                                                        prev.filter(
                                                          (item) =>
                                                            !(item.key === child.key && item.type === child.type)
                                                        )
                                                      );
                                                    }
                                                  }}
                                                />
                                              </div>

                                              <div className="icons">
                                                <div style={{ display: "flex", gap: "4px" }}>
                                                  <div>
                                                    {" "}
                                                    {child?.is_fav ? (
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-bookmark-fill"
                                                        viewBox="0 0 16 16"
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          handleFav(child);
                                                        }}
                                                        style={{
                                                          fontSize: "18px",
                                                          color: "black",
                                                        }}
                                                      >
                                                        <path d="M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2" />
                                                      </svg>
                                                    ) : (
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        fill="currentColor"
                                                        className="bi bi-bookmark"
                                                        viewBox="0 0 16 16"
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          handleFav(child);
                                                        }}
                                                        style={{
                                                          fontSize: "18px",
                                                          color: "black",
                                                        }}
                                                      >
                                                        <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z" />{" "}
                                                      </svg>
                                                    )}
                                                  </div>
                                                  {
                                                    <>
                                                      {child?.commit_count > 0 ? (
                                                        <Badge count={child?.commit_count} size="small">
                                                          <CommentOutlined
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              handleAddCommentList(child);
                                                            }}
                                                            style={{
                                                              fontSize: "18px",
                                                              color: "black",
                                                            }}
                                                          />
                                                        </Badge>
                                                      ) : (
                                                        <CommentOutlined
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleAddCommentList(child);
                                                          }}
                                                          style={{
                                                            fontSize: "18px",
                                                            color: "black",
                                                          }}
                                                        />
                                                      )}
                                                    </>
                                                  }
                                                </div>
                                              </div>
                                            </div>
                                            <RightBrief
                                              node={child}
                                              isLastElement={processedChildren?.length == i + 1}
                                              handleItemClick={handleItemClick}
                                              Permission={Permission}
                                              setSelectedKey={setSelectedKey}
                                              combinedResponse={combinedResponse}
                                              setBreadcrumb={setBreadcrumb}
                                              breadcrumb={breadcrumb}
                                              setSelectedNodeData={setSelectedNodeData}
                                              setResetNodeData={setResetNodeData}
                                              setShowInnerFolder={setShowInnerFolder}
                                              expandedKeys={expandedKeys}
                                              setExpandedKeys={setExpandedKeys}
                                              handleDeleteModal={handleDeleteModal}
                                              handleRenameFolder={handleRenameFolder}
                                              selectedType={selectedType}
                                              selectedItems={selectedItems}
                                              setDownloading={setDownloading}
                                              setDownloadingProgress={setDownloadingProgress}
                                              handleMoveFiles={handleMoveFiles}
                                              handleShareFiles={handleShareFiles}
                                              handleLockFolder={handleLockFolder}
                                              setLockOpen={setLockOpen}
                                              // handleRecentTracker={handleRecentTracker}
                                              setProtectedSlug={setProtectedSlug}
                                              setProtectedLockData={setProtectedLockData}
                                              userInfo={userInfo}
                                              socket={socket}
                                            />
                                          </Tooltip>
                                        </>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="noFound_wrapper" onContextMenu={handleRightClickPaste}>
                            <img src={noFoundImg} alt="img" loading="lazy" />
                            Folder is empty
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="bd_doc_folder treeSpinner">
                          {" "}
                          <Spin size="large" />
                        </div>
                      </>
                    )}
                  </div>
                ) : (
                  <>
                    <div>
                      <h3 style={{ color: "black", padding: "15px" }}>Searched Data</h3>
                      <div style={{ padding: "15px" }}>
                        <Table columns={columns} dataSource={filteredData} bordered pagination={{ pageSize: 10 }} />
                      </div>
                    </div>
                  </>
                )}
              </Col>
            </Row> */}
          </div>
        </div>
      </div>

      <div>
        {showCount && visibleCount > 0 && showDataAcc.length == [] && (
          <div className="button_loading">
            <button
              onClick={() => {
                if (scrollRef.current) {
                  scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
                }
              }}
            >
              <svg width="17" height="17" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                <path d="M24 6V42" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                <path
                  d="M12 18L24 6L36 18"
                  stroke="#fff"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {visibleCount} Files
            </button>
          </div>
        )}
      </div>

      {isLoading && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <span>Loading...</span>
        </div>
      )}

      <UploadDoc
        open={uploadDocModal}
        setOpen={setUploadDocModal}
        loadings={loadings}
        fetchBriefFolderList={fetchBriefFolderList}
        handleClose={handleClose}
        handleLoading={handleLoading}
        triggerFileInput={triggerFileInput}
        selectedNodeData={selectedNodeData}
        uploadingFolder={uploadingFolder}
        Permission={Permission}
        userInfo={userInfo}
        socket={socket}
      />

      <RenameDocument
        open={openRenameFolder}
        setOpen={setOpenRenameFolder}
        renameKeys={renameKeys}
        loadings={loadings}
        fetchBriefFolderList={fetchBriefFolderList}
        handleLoading={handleLoading}
        currentFolderKey={currentFolderKey}
        renameFolder={renameFolder}
        userInfo={userInfo}
        socket={socket}
      />

      <FileCreateUpdate
        open={openFileCreate}
        setOpen={setOpenFileCreate}
        loadings={loadings}
        fetchBriefFolderList={fetchBriefFolderList}
        handleLoading={handleLoading}
        parentId={selectedNodeData?.key}
        userInfo={userInfo}
        socket={socket}
      />

      <FolderCreateUpdate
        open={basicModal}
        setOpen={setBasicModal}
        loadings={loadings}
        fetchBriefFolderList={fetchBriefFolderList}
        handleLoading={handleLoading}
        parentId={selectedNodeData?.key}
        folderSlug={folderSlug}
        userInfo={userInfo}
        socket={socket}
      />

      <Delete
        title={"Briefcase"}
        fetchBriefFolderList={fetchBriefFolderList}
        open={deleteModal}
        onClose={() => setDeleteModal(false)}
        modalData2={modalData}
        userInfo={userInfo}
        socket={socket}
      />

      <CommentModal
        commentModal={commentModal}
        setCommentModal={setCommentModal}
        showComments={showComments}
        currentItemData={currentItemData}
        selectedNodeData={selectedNodeData}
        setSelectedNodeData={setSelectedNodeData}
        handleAddCommentList={handleAddCommentList}
      />

      <ShareFile
        shareFileOpen={shareFileOpen}
        setShareFileOpen={setShareFileOpen}
        shareData={shareData}
        shareLink={shareLink}
        setShareLink={setShareLink}
      />
      <ProtectedFolder
        lockOpen={lockOpen}
        setLockOpen={setLockOpen}
        lockData={lockData}
        protectedLockData={protectedLockData}
        protectedSlug={protectedSlug}
        selectedNodeData={selectedNodeData}
        setSelectedNodeData={setSelectedNodeData}
        fetchBriefFolderList={fetchBriefFolderList}
      />
    </>
  );
}

export default Briefcase;
